import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { Routes, Route, useNavigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { uiActions } from "./Store/ui-slice";
import { auth } from "./Services/firebase-config";

import HomePage from "./Components/Pages/HomePage";
import NewNotePage from "./Components/Pages/NewNotePage";
import RegisterPage from "./Components/Pages/RegisterPage";
import NotFound from "./Components/Pages/NotFound";

const App = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    auth.onAuthStateChanged((currentUser) => {
      if (currentUser === null) {
        navigate("/", { replace: true });
        dispatch(uiActions.changeUserParamName({ userParamName: "" }));
        dispatch(uiActions.changeUserDBId({ userDBId: "" }));
      } else {
        dispatch(
          uiActions.changeUserParamName({
            userParamName: currentUser.displayName,
          })
        );
        dispatch(uiActions.changeUserDBId({ userDBId: currentUser.uid }));
      }
    });
  }, [dispatch, navigate]);

  return (
    <AnimatePresence>
      <Routes>
        <Route path="/:userId/new-note" exact element={<NewNotePage />} />
        <Route path="/:userId" exact element={<HomePage />} />
        <Route path="/" exact element={<RegisterPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
  );
};
export default App;
